import {
  LIST_NORMAL_DESCRIPTION_REQUEST,
  LIST_NORMAL_DESCRIPTION_SUCCESS,
  LIST_NORMAL_DESCRIPTION_FAILURE,
  LIST_NORMAL_DESCRIPTION_SUMMARY_REQUEST,
  LIST_NORMAL_DESCRIPTION_SUMMARY_SUCCESS,
  LIST_NORMAL_DESCRIPTION_SUMMARY_FAILURE,
  CREATE_NORMAL_DESCRIPTION_REQUEST,
  CREATE_NORMAL_DESCRIPTION_SUCCESS,
  CREATE_NORMAL_DESCRIPTION_FAILURE,
  DETAIL_NORMAL_DESCRIPTION_REQUEST,
  DETAIL_NORMAL_DESCRIPTION_SUCCESS,
  DETAIL_NORMAL_DESCRIPTION_FAILURE,
  UPDATE_NORMAL_DESCRIPTION_REQUEST,
  UPDATE_NORMAL_DESCRIPTION_SUCCESS,
  UPDATE_NORMAL_DESCRIPTION_FAILURE,
  DELETE_NORMAL_DESCRIPTION_REQUEST,
  DELETE_NORMAL_DESCRIPTION_SUCCESS,
  DELETE_NORMAL_DESCRIPTION_FAILURE
} from '../../constants/normal-descriptions'

const initialState = {
  loading: false,
  normalDescriptions: [],
  normalDescription: {},
  normalDescriptionSummary:[],
  error: null,
  pageable: {}
}

const normalDescriptionReducer = (state = initialState, action) => {
  switch (action.type) {
    case LIST_NORMAL_DESCRIPTION_REQUEST:
      return {
        ...state,
        loading: true
      }
    case LIST_NORMAL_DESCRIPTION_SUCCESS:
      return {
        ...state,
        loading: false,
        normalDescriptions: action.payload,
        pageable: action.pageable
      }
    case LIST_NORMAL_DESCRIPTION_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      }
    case LIST_NORMAL_DESCRIPTION_SUMMARY_REQUEST:
      return {
        ...state,
        loading: true
      }
    case LIST_NORMAL_DESCRIPTION_SUMMARY_SUCCESS:
      return {
        ...state,
        loading: false,
        normalDescriptionSummary: action.payload
      }
    case LIST_NORMAL_DESCRIPTION_SUMMARY_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      }
    case CREATE_NORMAL_DESCRIPTION_REQUEST:
      return {
        ...state,
        loadingCreate: true
      }
    case CREATE_NORMAL_DESCRIPTION_SUCCESS:
      return {
        ...state,
        loadingCreate: false
      }
    case CREATE_NORMAL_DESCRIPTION_FAILURE:
      return {
        ...state,
        loadingCreate: false,
        error: action.payload
      }
    case DETAIL_NORMAL_DESCRIPTION_REQUEST:
      return {
        ...state,
        loadingDetail: true
      }
    case DETAIL_NORMAL_DESCRIPTION_SUCCESS:
      return {
        ...state,
        loadingDetail: false,
        normalDescription: action.payload
      }
    case DETAIL_NORMAL_DESCRIPTION_FAILURE:
      return {
        ...state,
        loadingDetail: false,
        error: action.payload
      }
    case UPDATE_NORMAL_DESCRIPTION_REQUEST:
      return {
        ...state,
        loadingUpdate: true
      }
    case UPDATE_NORMAL_DESCRIPTION_SUCCESS:
      const normalDescriptionPayloadUpdate = action.payload
      const normalDescriptionIdUpdate = action.normalDescriptionId

      const normalDescriptionsUpdate = [...state.normalDescriptions]
      const normalDescriptionIndexUpdate = normalDescriptionsUpdate.findIndex(normalDescription => normalDescription.id === normalDescriptionIdUpdate)
      normalDescriptionsUpdate[normalDescriptionIndexUpdate] = normalDescriptionPayloadUpdate

      return {
        ...state,
        loadingUpdate: false,
        normalDescriptions: normalDescriptionsUpdate
      }
    case UPDATE_NORMAL_DESCRIPTION_FAILURE:
      return {
        ...state,
        loadingUpdate: false,
        error: action.payload
      }
    case DELETE_NORMAL_DESCRIPTION_REQUEST:
      return {
        ...state,
        loadingDelete: true
      }
    case DELETE_NORMAL_DESCRIPTION_SUCCESS:
      const normalDescriptionIdDelete = action.payload
      const normalDescriptionsDelete = [...state.normalDescriptions]
      const normalDescriptionIndexDelete = normalDescriptionsDelete.findIndex(normalDescription => normalDescription.id === normalDescriptionIdDelete)
      normalDescriptionsDelete.splice(normalDescriptionIndexDelete, 1)

      return {
        ...state,
        loadingDelete: false,
        normalDescriptions: normalDescriptionsDelete
      }
    case DELETE_NORMAL_DESCRIPTION_FAILURE:
      return {
        ...state,
        loadingDelete: false,
        error: action.payload
      }
    default:
      return state
  }
}

export default normalDescriptionReducer